import { HawaPanel } from '../types'

import component from './io-field.component.vue'
import editor from './io-field.editor.vue'
// import { Attribute } from './types'

export default class IOField implements HawaPanel {
  name = 'IOFieldV'
  title = 'IO Field Vert'
  component = component
  editor = editor
  snapshot = {
    DeletedAt: null,
    title: 'IO Field Vert',
    component: 'IOFieldV',
    query: [],
    layout: { h: 9, i: '1597804192412', moved: false, w: 16, x: 16, y: 18 },
    attributes: {
      background: '#d4a0a0',
      cyclicUpdate: false,
      headerAlign: 'center',
      headerBackground: 'rgb(255,255,255)',
      headerForeground: 'rgb(0,0,0)',
      headerShow: true,
      labelStyle: {
        'background-color': '#ffffff',
        border: '',
        color: '#0033ff',
        'font-size': '10px',
        padding: '4px',
        'text-align': 'left',
        width: '30px',
      },
      labelText: 'SO<sub>2</sub>',
      rowEvenBackground: 'rgb(0,0,0)',
      rowOddBackground: 'rgb(0,0,0)',
      showHeader: true,
      tag: 'OSx7fzjZz',
      'title.show': false,
      unitStyle: {
        'background-color': '#ffffff',
        color: '#002feb',
        'font-size': '10px',
        padding: '4px',
        width: '10px',
      },
      unitText: 'ppm',
      updateInterval: 3000,
      valueMax: 39,
      valueMin: 20,
      valuePrecision: 2,
      valueStyle: {
        'background-color': '#050dff',
        color: '#ffffff',
        'font-size': '12px',
        'font-weight': '300',
        padding: '4px',
        'text-align': 'left',
      },
    },
  }

  init = {
    id: 0,
    DeletedAt: null,
    title: 'IO Field Vert',
    component: 'IOFieldV',
    query: [],
    layout: { h: 20, i: '1598052505806', moved: false, w: 90, x: 0, y: 0 },
    attributes: {
      background: '#d4a0a0',
      cyclicUpdate: false,
      labelStyle: {
        'background-color': 'rgb(12 179 255)',
        border: '',
        color: '#ffffff',
        'font-size': '30px',
        padding: '10px',
        'text-align': 'center',
        width: '100%',
      },
      labelText: 'default',
      panelHeader: { show: false, style: {} },
      rowEvenBackground: 'rgb(0,0,0)',
      rowOddBackground: 'rgb(0,0,0)',
      showHeader: true,
      tag: '',
      'title.show': false,
      unitStyle: {
        'background-color': 'rgb(12 179 255)',
        color: '#fff',
        'font-size': '70px',
        padding: '0',
        width: '0',
      },
      unitText: '%',
      updateInterval: 3000,
      valueMax: 220,
      valueMin: 0,
      valuePrecision: 2,
      valueStyle: {
        'background-color': 'rgb(12 179 255)',
        color: '#ffffff',
        'font-size': '70px',
        'font-weight': 'bolder',
        padding: '10px',
        'text-align': 'center',
        width: '100%',
      },
    },
  }
}
